import { ComponentProps, Suspense, lazy } from 'react';
import Preloader from '../../atoms/Preloader';

const FilePreviewModal = lazy(() => import('./FilePreviewModal'));

/** Окно предпросмотра с ленивой загрузкой: просмотрщики и pdf.js приходят отдельным чанком при первом открытии. */
const LazyFilePreviewModal = (props: ComponentProps<typeof FilePreviewModal>) => (
    <Suspense fallback={<Preloader size="lg" label="Загрузка просмотра…" />}>
        <FilePreviewModal {...props} />
    </Suspense>
);

export default LazyFilePreviewModal;
